import {Injectable} from '@angular/core';
import {Action, createSelector, State, StateContext} from '@ngxs/store';
import {patch} from '@ngxs/store/operators';
import {LoadSearchEvents} from '@store/search-ott-events/search-ott-events.actions';
import {JsonApiResponse} from '@tisa-group/cdk';
import {OttEventService} from '@tisa-group/core/api/umpire';
import {UmpireOttEvent} from '@tisa-group/models';
import {Observable, tap} from 'rxjs';

export type SearchEventsStateModel = Record<string, JsonApiResponse<UmpireOttEvent[]>>;

@State<SearchEventsStateModel>({
  name: 'SearchEvent',
  defaults: undefined,
})
@Injectable()
export class SearchEventsState {
  @Action(LoadSearchEvents)
  LoadSearchEvents(
    ctx: StateContext<SearchEventsStateModel>,
    action: LoadSearchEvents,
  ): Observable<JsonApiResponse<UmpireOttEvent[]>> | JsonApiResponse<UmpireOttEvent[]> {
    const {filter} = action;
    const stateEvent = ctx.getState()[filter];

    if (stateEvent) {
      return stateEvent;
    }

    return this.eventService
      .list({
        include: ['image_horizontal', 'format'].join(','),
        // Filter mirrors logic on mobile, if # is present we search for tags
        filter: filter.includes('#')
          ? {
              tags_name: {
                rule: 'i_cont',
                value: filter.replace(/#/g, ''),
              },
            }
          : {search: {value: filter}},
        sort: ['custom_events_sort'],
        page: {
          size: 30,
          number: 0,
        },
      })
      .pipe(
        tap(res =>
          ctx.setState(
            patch({
              [filter]: res,
            }),
          ),
        ),
      );
  }

  static getSearchEvents(
    filter: string,
  ): (state: SearchEventsStateModel) => JsonApiResponse<UmpireOttEvent[]> {
    return createSelector<
      (state: SearchEventsStateModel) => JsonApiResponse<UmpireOttEvent[]>
    >([SearchEventsState], state => {
      return state[filter];
    });
  }

  constructor(readonly eventService: OttEventService) {}
}
